import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { PaginationEmpty, QueryPagination } from 'domain/models/queryPagination'
import { Destination, ReadDestinationsQueryResponse } from 'domain/entities/destination'
import { DestinationState } from 'domain/models/destination'
import { RootState } from 'presentation/redux/reducers'

const initialState: DestinationState = {
  error: null,
  isLoading: false,
  destinations: [],
  pagination: PaginationEmpty,
}
export const destinationSlice = createSlice({
  name: 'destination',
  initialState,
  reducers: {
    getDestinationsStart: (state: DestinationState) => {
      state.isLoading = true
      state.error = null
    },
    getDestinationsSuccess: (
      state: DestinationState,
      action: PayloadAction<ReadDestinationsQueryResponse>,
    ) => {
      state.isLoading = false
      state.destinations = action.payload.entities as Destination[]
      state.pagination = action.payload.pagination as QueryPagination
    },
    getDestinationsError: (state: DestinationState, action: PayloadAction<string | null>) => {
      state.isLoading = false
      state.error = action.payload
    },
  },
})
export const { getDestinationsStart, getDestinationsSuccess, getDestinationsError } =
  destinationSlice.actions

export const destinationState = (state: RootState) => state.destination
export default destinationSlice.reducer
